import React, { useState } from 'react';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import ActionMenu from '../../../../components/ui/materialui/actionMenu';
import { Delete, Download, Send, Visibility } from '@mui/icons-material';
import { EstadoSubsidioMinvu, SeguroMinvu, StatusCode, TipoArchivo } from '../../../../utils/enums';
import { useToast } from '../../../../hooks/useToast';
import { descargarExcelCobroMinvu, descargarExcelValidacionMinvu, descargarTxtCobroMinvu, descargarTxtValidacionMinvu } from '../../../detalleMutuo/services/servicesReportes';
import { cambiarEstado, eliminarArchivo, eliminarListadoArchivo } from '../services/segurosServices';
import { Archivominvu, ArgumentosCambiarEstado } from '../models/cobroSeguros';
import ModalListArchivo from './modalListArchivo';

interface IProps {
    data: Archivominvu;
    renderizar: () => void;
}

const Acciones: React.FC<IProps> = ({ data, renderizar }) => {
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });
    const [showModalArchivo, setShowModalArchivo] = React.useState<boolean>(false);


    const { addToast } = useToast();

    const handleDeshacerCobro = async () => {

        setModalConfirmacion({
            show: true,
            title: "Deshacer cobro",
            message: "¿Desea deshacer el cobro?",
            metodo: async () => {

                const request: ArgumentosCambiarEstado = {
                    id: data.id,
                    estado: SeguroMinvu.ESTADOSEGUROMINVU_NO_COBRADO
                };

                const resp = await cambiarEstado(request)
                if (resp.status === StatusCode.Ok) {
                    renderizar();
                    addToast({
                        mostrar: true,
                        titulo: 'Confirmación',
                        tipo: 'Success',
                        mensaje: 'Se ha deshecho el cobro correctamente'
                    });
                }
            },
        });
    }

    const handleCobro = async () => {
        setModalConfirmacion({
            show: true,
            title: "Generar cobro",
            message: "¿Desea generar el cobro?",
            metodo: async () => {

                const request: ArgumentosCambiarEstado = {
                    id: data.id,
                    estado: SeguroMinvu.ESTADOSEGUROMINVU_COBRADO
                };

                const resp = await cambiarEstado(request)
                if (resp.status === StatusCode.Ok) {
                    renderizar();
                    addToast({
                        mostrar: true,
                        titulo: 'Confirmación',
                        tipo: 'Success',
                        mensaje: 'Se ha generado el cobro correctamente'
                    });
                }
            },
        });
    }

    const handleEliminarListado = async () => {

        setModalConfirmacion({
            show: true,
            title: "Eliminar listado",
            message: "¿Desea eliminar el listado MINVU?",
            metodo: async () => {
                const resp = await eliminarArchivo(data.id);
                if (resp.status === StatusCode.NoContent) {
                    renderizar();
                    addToast({
                        mostrar: true,
                        titulo: 'Confirmación',
                        tipo: 'Success',
                        mensaje: 'Se ha eliminado correctamente'
                    });
                }
            },
        });

    }
    const handleVerListadoArchivo = async () => {
        setShowModalArchivo(true);

    }

    const actions = [
        {
            label: 'Generar cobro',
            icon: <Send fontSize="small" />,
            onClick: handleCobro,
        },
        {
            label: 'Deshacer cobro',
            icon: <Delete fontSize="small" />,
            onClick: handleDeshacerCobro,
        },
        {
            label: 'Ver listado',
            icon: <Visibility fontSize="small" />,
            onClick: handleVerListadoArchivo,
        },
        {
            label: 'Eliminar',
            icon: <Download fontSize="small" />,
            onClick: handleEliminarListado,
        }
    ];

    console.log('data', data)

    return (
        <>
            <ModalListArchivo
                show={showModalArchivo}
                onHide={() => setShowModalArchivo(false)}
                data={data}
            />
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />
            <ActionMenu actions={actions} />
        </>

    );
};

export default Acciones;
